import React from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

const CalendarPopup = ({
  showCalendar,
  setShowCalendar,
  onDateRangeSelect,
}) => {
  const [startDate, setStartDate] = React.useState(null);
  const [endDate, setEndDate] = React.useState(null);
  const [selectedDate, setSelectedDate] = React.useState(new Date());

  const handleCalendarClick = (date) => {
    setSelectedDate(date);
    if (!startDate) {
      setStartDate(date);
    } else if (!endDate) {
      setEndDate(date);
    } else {
      setStartDate(date);
      setEndDate(null);
    }
  };

  const handleCancelClick = () => {
    setStartDate(null);
    setEndDate(null);
    setShowCalendar(false);
  };

  const handleApplyClick = () => {
    if (startDate && endDate) {
      onDateRangeSelect(startDate, endDate);
      setShowCalendar(false);
    }
  };

  if (!showCalendar) return null;

  return (
    <div className="calendar-popup">
      <div className="calendar-header">
        <input
          type="text"
          placeholder="Start date"
          value={startDate ? startDate.toLocaleDateString() : "Start date"}
          readOnly
        />
        <span> - </span>
        <input
          type="text"
          placeholder="End date"
          value={endDate ? endDate.toLocaleDateString() : "End date"}
          readOnly
        />
      </div>
      <Calendar onClickDay={handleCalendarClick} value={selectedDate} />
      <div className="calendar-footer">
        <button className="calendar-cancel-button" onClick={handleCancelClick}>
          Cancel
        </button>
        <button className="calendar-apply-button" onClick={handleApplyClick}>
          Apply
        </button>
      </div>
    </div>
  );
};

export default CalendarPopup;
